var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"cols":"8"}},[_c('b-card',[_c('b-col',{staticClass:"col-12 text-center"},[_c('img',{attrs:{"src":require("@/assets/images/approve/1.png"),"width":"100%"}})])],1)],1),_c('RightTab')],1)}
var staticRenderFns = []

export { render, staticRenderFns }